import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Estado del modal de DETALLE de una cotización (incidente #27).
 * El estándar del CRM es presentar el detalle en un modal (contactos, empresas, negocios, leads,
 * tickets, tareas, productos...), no como una vista aparte. Este servicio permite abrirlo como
 * overlay desde la lista sin navegar a otra pantalla.
 *
 * La ruta /cotizaciones/detalle/:id sigue funcionando para deep-linking (notificaciones): en ese
 * caso el modal se monta en modo "ruta" y al cerrar navega de vuelta a /cotizaciones.
 */
export interface QuoteDetailModalState {
  open: boolean;
  /** id de la cotización a mostrar; undefined = cerrado. */
  quoteId?: number;
}

@Injectable({ providedIn: 'root' })
export class QuoteDetailModalService {
  private readonly stateSubject = new BehaviorSubject<QuoteDetailModalState>({ open: false });
  readonly state$ = this.stateSubject.asObservable();

  open(quoteId: number): void {
    this.stateSubject.next({ open: true, quoteId });
  }

  close(): void {
    this.stateSubject.next({ open: false });
  }
}
